import { Navigate } from 'react-router-dom';
import { ClerkOpsConsole, useClerkOpsEnabled } from '../features/clerk-ops';

export default function ClerkOpsPage() {
  const { data: enabled, isLoading } = useClerkOpsEnabled();

  // Hidden for every tenant without the feature: bounce to dashboard rather
  // than reveal the surface exists.
  if (isLoading) return null;
  if (!enabled) return <Navigate to="/dashboard" replace />;

  return (
    <div className="mx-auto max-w-7xl p-6">
      <ClerkOpsConsole />
    </div>
  );
}
